import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type LocaleMessages } from 'vue-i18n';

import { AppI18n } from './i18nSetup';

export async function createI18nByPlatform(
  locale?: HgSupportedLanguage,
  translations?: LocaleMessages<any>,
): Promise<AppI18n> {
  const defaultTranslations = await import('@/i18n/de-hg');
  return new AppI18n(locale ?? HgSupportedLanguage.DE, translations ?? defaultTranslations.default);
}
